import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "chevron"]

  connect() {
    // Por defecto, el resumen está colapsado
    this.collapse()
  }

  toggle() {
    if (this.isExpanded()) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.contentTarget.classList.remove("hidden")
    // Cuando está expandido, el chevron apunta hacia arriba (rotate-0)
    this.chevronTarget.classList.remove("rotate-180")
    this.chevronTarget.classList.add("rotate-0")
  }

  collapse() {
    this.contentTarget.classList.add("hidden")
    // Cuando está colapsado, el chevron apunta hacia abajo (rotate-180)
    this.chevronTarget.classList.remove("rotate-0")
    this.chevronTarget.classList.add("rotate-180")
  }

  isExpanded() {
    return !this.contentTarget.classList.contains("hidden")
  }
}
